import * as ng from 'angular';

export const Ngenter = () => (<angular.IDirective>{
    link: (scope: any, element: JQLite, attrs: any) => {
        element.bind('keypress', (event) => {
            if (event.which === 13) {
                scope.$apply(() => {
                    scope.$eval(attrs.ngenter);
                });
                event.preventDefault();
            }
        });
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/ngenter/ngenter.directive.ts